import React from 'react';
import { InputBaseComponentProps } from '@mui/material';
import MaskedTextField from './MaskedTextField';

interface PhoneNumberFieldProps extends InputBaseComponentProps {
  id: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
}

function PhoneNumberField({ id, value, onChange, label, ...other }: PhoneNumberFieldProps) {
  return (
    <MaskedTextField
      {...other}
      id={id}
      placeholder="(XXX) XXX-XXXX"
      format="(###) ###-####"
      value={value}
      onChange={onChange}
      label={label}
    />
  );
}

export default PhoneNumberField;
